import { Component, Inject } from "@angular/core";
import { MatDialogRef, MAT_DIALOG_DATA } from "@angular/material";

@Component({
    selector: 'app-dialog-conferma-input',
    templateUrl: './dialog-conferma-input.component.html',
    styleUrls: ['./dialog-conferma-input.component.css']
})
export class DialogConfermaInputComponent {

    testo: string = '';

    constructor(
        public dialogRef: MatDialogRef<DialogConfermaInputComponent>,
        @Inject(MAT_DIALOG_DATA) public data: { titolo: string, messaggio: string }
    ) {
    }

    si() {
        this.dialogRef.close({ conferma: true, testo: this.testo });
    }
    no() {
        this.dialogRef.close({ conferma: false })
    }
}



// WEBPACK FOOTER //
// /home/david/vscode-workspace/TOP-casa-nel-web/frontend/src/app/components/utilita/dialogs/dialog-conferma-input/dialog-conferma-input.component.ts